module.exports = __webpack_public_path__ + "img/ScooterBG@2x.fc1bcb04.png";